export default class ClerkService {
    categories = [];
    keyAccount = null;
    siteId = window.platform.clerkSiteId;
    clerkAreaName = window.platform.clerkAreaName;
    clerkId = window.platform.clerkID;

    constructor({siteId, clerkId}) {
        this.siteId = siteId ? siteId : this.siteId;
        this.clerkId = clerkId ? clerkId : this.clerkId;
        if (this.clerkId) {
            this.setupClerk();
        }
    }

    async setupClerk() {
        this.categories = await this.getCategories();
        this.keyAccount = await this.getKeyAccount();
        history.replaceState && history.replaceState(null, "", this.enrichedUrl.href);

        this.loadClerk();
    }

    async getCategories() {
        try {
            const res = await fetch(`/api/shop/categories/${this.siteId}`);
            return await res.json();
        } catch (error) {
            //console.error(error);
        }
    }

    async getKeyAccount() {
        try {
            const res = await fetch(`/api/cart/keyaccount`);
            return await res.json();
        } catch (error) {
            //console.error(error);
        }
    }

    get enrichedUrl() {
        const currentUrl = new URL(window.location.href);
        if (this.keyAccount) {
            currentUrl.searchParams.set("keyAccounts", this.keyAccount.password);
        }
        if (this.clerkAreaName) {
            currentUrl.searchParams.set("area", this.clerkAreaName);
        }

        return currentUrl;
    }

    loadClerk() {
        var e = document.createElement("script");
        e.type = "text/javascript";
        e.async = true;
        e.src = (document.location.protocol == "https:" ? "https" : "http") + "://cdn.clerk.io/clerk.js";

        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(e, s);
        window.__clerk_q = window.__clerk_q || [];
        window.Clerk =
            window.Clerk ||
            function () {
                window.__clerk_q.push(arguments);
            };

        window.Clerk("config", {
            key: this.clerkId,
            visitor: "auto",
            collect_email: true,
            formatters: {
                getCategoryNameById: ([catID]) => {
                    const category = this.categories.find((cat) => {
                        return cat.id == catID;
                    });

                    return category != null ? category.name : "";
                }
            }
        });
    }
}